import { useStore } from '../../store/store';
import { isAImgBox, isAVariableBox } from '../../utils/boxes';
import { iconButtonStyle } from '../../utils/styles';
import { NavbarButton } from './NavbarButton';
import DuotoneLightIcon from '../common/DuotoneLightIcon';
import KeepTooltip from '../common/KeepTooltip';

const selector = ({
  selectedBoxId,
  boxes,
  masks,
  maskEditing,
  containers,
  currentProposal,
  columns,
  updateBox,
}) => {
  const box = [
    ...boxes,
    ...masks.map((m) => m.boxes).flat(),
  ].find((b) => selectedBoxId && b.id === selectedBoxId);

  const container = box
    ? containers.find((c) => c.columnsIds.includes(box.columnId))
    : null;
  const column = box
    ? columns.find((c) => c.id === box.columnId)
    : null;

  return {
    selectedBox: box,
    container,
    maskEditing,
    currentProposal,
    isInDrawMode: !!(column && column.drawMode),
    updateBox,
  };
};

export const BoxLockManager = () => {
  const {
    selectedBox,
    container,
    maskEditing,
    currentProposal,
    isInDrawMode,
    updateBox,
  } = useStore(selector);

  const hasSelectedBox = !!selectedBox;
  const isTemplate = currentProposal?.id == null;
  const isMaskEditingMode = maskEditing?.length > 0;

  const isDisabled = () => {
    if (!hasSelectedBox) return true;
    if (!isMaskEditingMode && !isInDrawMode) return true;
    if (!isMaskEditingMode && !container) return true;
    // Même logique que BorderManager pour l'édition en proposition
    if (
      !container?.editable &&
      Object.prototype.hasOwnProperty.call(container || {}, 'editable') &&
      !isTemplate
    ) {
      // Autoriser tout de même les images / variables images comme ailleurs
      if (isAImgBox(selectedBox.type) || isAVariableBox(selectedBox.type)) {
        return false;
      }
      return true;
    }
    return false;
  };

  const hidden = !hasSelectedBox || (!isInDrawMode && !isMaskEditingMode);

  const toggleLock = () => {
    if (!selectedBox) return;
    updateBox(selectedBox.id, (b) => {
      if (b.lockedPosition) {
        delete b.lockedPosition;
      } else {
        b.lockedPosition = true;
      }
    });
  };

  const tooltip =
    selectedBox?.lockedPosition ? 'Position figée' : 'Positionnement libre';

  return (
    <>
      {!hidden && (
        <div
          className='navbar__common-properties-container'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <KeepTooltip>
          <NavbarButton
            tooltipContent={tooltip}
            icon={
              selectedBox?.lockedPosition ? (
                <i
                  className='fa-kit fa-light-arrows-maximize-lock'
                  style={{ ...iconButtonStyle(), paddingBottom: '5px' }}
                />
              ) : (
                <DuotoneLightIcon name='arrows-maximize' style={iconButtonStyle()} />
              )
            }
            disabled={isDisabled()}
            onClick={toggleLock}
          />
          </KeepTooltip>
        </div>
      )}
    </>
  );
};
